// @flow

import * as React from 'react';
import { localize } from '@ta/common.i18n';
import { bind } from '@ta/common.api';
import styles from './DDLogo.less';

export type LogoData = {
  dd_logo_svg: string,
};

type Props = {
  logoData: LogoData,
};

const DDLogo = ({ logoData }: Props) => (
  <div className={styles.logo_slogan}>
    <img
      className={styles.logo_cn}
      src={logoData.dd_logo_svg}
      alt={localize('common_TripAdvisor')}
    />
  </div>
);

export default bind<Props, {||}, _, _, _, _>((state, stage) => {
  const logoApiCall = stage(`/data/1.0/daodao/brand/logo`);

  return () => {
    const data = logoApiCall.get().data || {};
    return {
      logoData: data,
    };
  };
})(DDLogo);
